<template>
  <div class="custom-select" :class="{ 'is-error': hasError }" ref="select">
    <div class="selected-option" @click="isOpen = !isOpen">
      <span v-if="!selectedOption" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
        <span>
          {{ placeholder }}
        </span>
        <img v-if="type=='time'" src="@/assets/images/icons/finance-time.png" alt="clock icon" />
        <img v-else src="@/assets/images/icons/interface-arrow-dropdown.png" :alt="`dropdown icon`" />
      </span>
      <span
        v-else-if="type == 'time'"
        style="display: flex; justify-content: space-between; align-items: center; width: 100%;"
      >
        <span>
          {{ options[selectedIndex]}}
        </span>
        <img src="@/assets/images/icons/finance-time.png" alt="clock icon" />
      </span>
      <span v-else-if="type == 'country'">
        {{ selectedOption.name }}
      </span>
      <span v-else>
        {{ selectedOption }}
      </span>
    </div>
    <div class="options" v-show="isOpen">
      <div
        class="option"
        v-for="(option, index) in options"
        :key="index"
        @click="selectOption(option, index)"
      >
        <span v-if="type == 'time'">
          {{ options[index] }}
        </span>
        <span v-else-if="type == 'country'">
          {{ option.name }}
        </span>
        <span v-else>
          {{ option }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomSelect",
  data() {
    return {
      isOpen: false,
      selectedOption: null,
      selectedIndex: null,
    };
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      required: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    selectOption(option, index) {
      this.selectedOption = option;
      this.selectedIndex = index;
      this.isOpen = false;
      if (this.type == "country") {
        this.$emit("input", option.code);
      } else {
        this.$emit("input", option);
      }
    },
    handleClickOutside(event) {
      if (!this.$refs.select.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    if (this.value) {
      const index = this.options.findIndex((option) => {
        if (this.type === 'country') {
          return option.code === this.value
        }
        return option === this.value
      });
      if (index > -1) {
        this.selectOption(this.options[index], index);
      }
    }
  },
  watch: {
    isOpen(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          const optionsContainer = this.$refs.select.querySelector(".options");
          // log optionsContainer.scrollHeight
          optionsContainer.scrollBy(0, 1);
          optionsContainer.scrollBy(0, -1);
        });
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.custom-select {
  position: relative;
  background-color: #f6f6f4;
  height: 64px;
  border-radius: 8px;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  width: 100%;
}
.selected-option {
  background-color: #f6f6f4;
  height: 64px;
  width: 100%;
  border-radius: 8px;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: 16px;
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  cursor: pointer;
}
.options {
  position: absolute;
  max-height: 400px;
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  overflow-y: scroll;
  /* -ms-overflow-style: none; */
  /* scrollbar-width: none; */
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05), 0px 4px 4px -1px rgba(0, 0, 0, 0.05),
    0px 12px 16px -8px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
}
/*   display: none; */
.options::-webkit-scrollbar {

}
.option {
  padding: 16px;
  cursor: pointer;
  border-radius: 8px;
  width: 100%;
}
.option:hover {
  background: #f2f3f4;
}
.is-error {
  box-shadow: 0px 0px 0px 1px red !important;
}
</style>
